<template>
  <div class="container bottom-fix-padding">
    <v-address v-if="ifAddr" @change="changeAddr" @close="addrClose()"></v-address>
    <div v-show="!ifAddr">
      <div class="navi">
          <span class="icon-arrow-left" @click="goto('/move-step3')"></span><div class="addr-title">途经点</div><span></span>
      </div>
      <div class="weui-cells__title">个人信息</div>
      <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
              <div class="weui-cell__hd"><label class="weui-label">联系人</label></div>
              <div class="weui-cell__bd">
                  <input class="weui-input" type="text" placeholder="请输入联系人名字" v-model="temp.name"/>
              </div>
          </div>
          <div class="weui-cell weui-cells_form">
              <div class="weui-cell__hd">
                  <label class="weui-label">手机号</label>
              </div>
              <div class="weui-cell__bd">
                  <input class="weui-input" type="tel" pattern="[0-9]*" placeholder="请输入手机号" v-model="temp.phone" />
              </div>
          </div>
      </div>
      <div class="weui-cells__title">服务地址</div>
      <div class="weui-cells weui-cells_form" v-if="!temp.street">
        <div class="weui-cell weui-cell_access padding-fix" @click="addrSelect()">
            <div class="weui-cell__hd"><label class="weui-label">地址</label></div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="text" readonly placeholder="如: 2/9 George Street" />
            </div>
            <div class="weui-cell__ft"></div>
        </div>

      </div>
      <div class="weui-cells" v-if="temp.street">
        <div class="weui-cell" @click="addrSelect()">
            <div class="weui-cell__hd">
                <label class="weui-label">详细地址</label>
            </div>
            <div class="weui-cell__bd">
                {{temp.street}} <br> {{ temp.suburb + " "+ temp.state + " " + temp.postcode}}
            </div>
        </div>

        <div class="deleteWP" v-if="this.$route.query.wpKey">
            <a @click="deleteWP" class="weui-btn weui-btn_warn">删除该途经点</a>
        </div>

        <div class="btn-box-fix">
          <div class="btn-container">

            <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}">保存途经点</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      'order':{},
      'address':{},
      'ifAddr':'',
      'temp':{
        'name':'',
        'phone':'',
        'street':'',
        'suburb':'',
        'state':'NSW',
        'name':'',
        'phone':'',
        'postcode':'',
        'unit':''
      }
    }
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "move"){
        this.order = localParsed;
        document.querySelector("html").classList.add("grey-background");
        if(this.temp.name==""&&this.order.data.move_out_name!=""){
            this.temp.name = this.order.data.move_out_name;
        }
        if(this.temp.phone==""&&this.order.data.move_out_phone!=""){
            this.temp.phone = this.order.data.move_out_phone;
        }
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
    if(this.temp.name==""&&localStorage.member_name){
        this.temp.name = localStorage.member_name;
    }
    if(this.temp.phone==""&&localStorage.member_phone){
        this.temp.phone = localStorage.member_phone;
    }
    if(this.$route.query.wpKey){
        this.temp = this.order.data.pathway_address[this.$route.query.wpKey];
    }
    if(localStorage.suburbTemp){
      this.temp = JSON.parse(localStorage.suburbTemp);
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  methods: {
    addrSelect: function() {
      this.rememberTop = window.scrollY;
      this.ifAddr=true;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    changeAddr: function(emit_street,emit_suburb,emit_state,emit_postcode) {
      this.temp.street = emit_street;
      this.temp.postcode = emit_postcode;
      this.temp.suburb = emit_suburb;
      this.temp.state = emit_state;
      this.sleep(10).then(() => {
          document.documentElement.scrollTop = this.rememberTop;
          document.body.scrollTop = this.rememberTop;
      });
      this.ifAddr=false;

    },
    addrClose: function() {
      this.sleep(10).then(() => {
          document.documentElement.scrollTop = this.rememberTop;
          document.body.scrollTop = this.rememberTop;
      });
      this.ifAddr=false;
    },
    deleteWP(){
      let result = window.confirm("确定要删除该途经点吗？");
      if(result){
        this.order.data.pathway_address.splice(this.$route.query.wpKey, 1);
        localStorage.removeItem('suburbTemp');
        this.orderUpdateAll('/move-step3');
      }
    },
    allFilled(){
        if(this.temp.name && this.temp.phone && this.temp.street && this.temp.suburb && this.temp.state && this.temp.name && this.temp.phone && this.temp.postcode){
            return true;
        }
    },
	formatCheck(){
	    // 检查手机号是否全为数字的正则表达式
	    const numberPattern = /^\d+$/;
	    
	    if (!this.temp.phone) {
	        alert('请填写手机号');
	    }
	    else if (this.temp.phone.length<8 || this.temp.phone.length>11) {
	        alert("手机号码长度不正确，请检查是否正确");
	    }
	    else if (!numberPattern.test(this.temp.phone)) {
	        alert("手机号码必须全部为数字");
	    }
	    else if(!this.temp.street){
	        alert('请填写搬出 Street');
	    }
	    else if (this.temp.street.length<8) {
	        alert('搬出Street长度太短，请检查是否正确');
	    }
	    else if (this.temp.street.length>50) {
	        alert('搬出Street长度太长，请检查是否正确');
	    }
	    else if (this.temp.postcode.length!=4) {
	        alert('请填写4位postcode号码');
	    }
	    else{
	        return true;
	    }
	},
    checkSubmit(){
      if(this.formatCheck()){
        if(this.allFilled()&&!this.$route.query.wpKey){
            this.order.data.pathway_address.push(this.temp);
            localStorage.removeItem('suburbTemp');
            this.orderUpdateAll('/move-step3');
        }
        else if(this.allFilled()&&this.$route.query.wpKey){
            this.order.data.pathway_address[this.$route.query.wpKey] = this.temp;
            localStorage.removeItem('suburbTemp');
            this.orderUpdateAll('/move-step3');
        }
        else{
            alert('请填写完所有地址信息')
        }
      }
    },
    calFloorFee(floor){
      let price = 0;
      switch (this.order.data.move_car) {
        case "1":
          price = 5;
          break;
        case "2":
          price = 15;
          break;
        case "3":
          price = 20;
          break;
        default:
          console.log("Sorry, we are out of control.");
      }
      let result = floor*price;
      return result;
    },
    wpOrderUpdate(){
      localStorage.suburbTemp = JSON.stringify(this.temp);
      let path ='/suburb?from=move_wp';
      if(this.$route.query.wpKey){
        path = path + '&wpKey=' + this.$route.query.wpKey;
      }
      this.$router.push(path);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.navi{
    display: flex;
    justify-content:space-between;
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
}

.container{
  background-color: #f8f8f8;
  padding-bottom:60px;
}
.weui-cells__title{
  margin-top:20px;
}


.addr-title{
    font-size:0.6em;
    line-height:2em;
    color:#444;
    vertical-align:top;
    display:inline-block;
    text-align:center;
}

.container /deep/ .weui-cells_checkbox .weui-check:checked+.weui-icon-checked:before{
  color: #fe9567;
}

.deleteWP{
    padding:18px;
}

.parking-icon{
    color:#fe9567;
    line-height:1.5;
}

.park-assist{
    text-align:center;
    color:#fe9567;
}

.padding-fix{
    padding-right:13px;
}

.placeholder-color{
    color:#777;
}
</style>



// WEBPACK FOOTER //
// src/pages/move/step3-address-wp.vue